import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import * as CommonBrowserUtils from "utilities/community/common-browser-utils/1.0.0/js/common-browser-utils";
import spartaMediaQueryConstantsUtility from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/sparta-mediaquery-constants-utility";
/**
 * @const utilityNamespace
 * @description namespace for our mediaquery utility
 */
export const utilityNamespace = 'spartaMediaQueryUtility';

/**
 * @const breakpointEventName
 * @description string to hold name of breakpoint Change event
 */
const breakpointEventName = 'BREAKPOINT_CHANGE';

/**
 * @const widgetResizeEventName
 * @description string to hold name for widget Resizing event
 */
const widgetResizeEventName = 'WIDGET_RESIZE';

/**
 * @const EVENTS
 * @description constant for storing namespaced event strings
 */
const EVENTS = {
  [breakpointEventName]: `${breakpointEventName}.${utilityNamespace}`,
  [widgetResizeEventName]: `${widgetResizeEventName}.${utilityNamespace}`,
};

export default EVENTS;
